import React from 'react';

interface BrandMarkProps {
  /** Размер стороны в px. По умолчанию наследует размер из CSS. */
  size?: number;
  className?: string;
  /** Знак декоративен, если рядом есть текстовое имя бренда. */
  title?: string;
}

/**
 * Знак QPrice — тот же, что на иконке мобильного приложения
 * (`qprice_mobile/ios/Runner/Assets.xcassets/AppIcon.appiconset`).
 *
 * Геометрия снята с иконки 1024×1024 и восстановлена примитивами, а не
 * трассировкой: кольцо — эллипс с типографской модуляцией штриха (по бокам
 * 95 единиц, сверху и снизу 86), хвост — прямоугольник под 45° с торцами,
 * срезанными перпендикулярно оси.
 *
 * Заливка — `currentColor`, поэтому знак одинаково работает на светлом и
 * тёмном и может быть перекрашен местом, где стоит.
 */
export const BrandMark: React.FC<BrandMarkProps> = ({ size, className, title }) => (
  <svg
    viewBox="0 0 448 448"
    width={size}
    height={size}
    className={className}
    fill="currentColor"
    role={title ? 'img' : undefined}
    aria-label={title}
    aria-hidden={title ? undefined : true}
    focusable="false"
  >
    <path
      fillRule="evenodd"
      d="M0 217A223.5 217 0 1 1 447 217A223.5 217 0 1 1 0 217ZM95 217A128.5 131 0 1 0 352 217A128.5 131 0 1 0 95 217Z"
    />
    <path d="M270 223L435.5 388.5L376.5 447.5L211 282Z" />
  </svg>
);
